'use strict';

var React = require('react');
var reactUtils = require('@sravni/react-utils');
var Row_module = require('../styles/Row.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

/**
 * @description Container element for Grid system.
 *
 * @component
 * @example
 * ```jsx
 * <Row gutter={[20, 20]} wrap>
 *   ...columns
 * </Button>
 * ```
 */
const Row = React__namespace.forwardRef((props, ref) => {
    const { className, gutter, align = 'top', justify, wrap, style, children, ...restProps } = props;
    const cx = reactUtils.useStyles(Row_module.default);
    const classNames = cx(className, 'container', {
        wrap,
        [`align-${align}`]: align,
        [`justify-${justify}`]: justify,
    });
    const gutters = React__namespace.useMemo(() => {
        const results = [0, 0];
        const normalizedGutter = Array.isArray(gutter) ? gutter : [gutter, 0];
        normalizedGutter.forEach((g, index) => {
            results[index] = g || 0;
        });
        return results;
    }, [gutter]);
    const rowStyle = { ...style };
    const horizontalGutter = gutters[0] > 0 ? gutters[0] / -2 : undefined;
    if (horizontalGutter) {
        rowStyle.marginLeft = horizontalGutter;
        rowStyle.marginRight = horizontalGutter;
    }
    const additionalProps = React__namespace.useMemo(() => ({ gutters }), [gutters]);
    return (React__namespace.createElement("div", { "data-qa": "Row", ref: ref, className: classNames, style: { ...rowStyle }, ...restProps }, React__namespace.Children.map(children, (child) => React__namespace.isValidElement(child) ? React__namespace.cloneElement(child, additionalProps) : child)));
});
Row.defaultProps = {
    gutter: 0,
    align: 'top',
    justify: 'start',
    wrap: true,
};
Row.displayName = 'Row';

exports.Row = Row;
//# sourceMappingURL=Row.js.map
